import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img1 from "../../images/events/latest-events.png";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

function LatestEvents(props) {
    return (
        <div className="latest-events p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="resp_order">
                        <div className="latest-event-img" >
                            <LazyLoadImage
                                src={Img1}
                                effect="blur" alt="latest-events" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example">
                            <h2>Latest Event:</h2>
                            <p>Each episode of Technology For Change explores the journey of successful entrepreneurs, and how someone took an idea and grew it into a successful business. We are coming forward with the aim to help bring in a positive change in people’s life using technological solutions.</p>
                            <p>Looking to scale your own business with the help of technology? Check out our business podcasts as we discuss how you can use technology to power the next cycle of growth for your business.</p>
                            <Link to="https://open.spotify.com/show/1erkBq21q0yc12QZiUeTlB?si=tr9png3hSB2vmKfAYWC3gg&nd=1"
                                  className="border_btn" aria-label="TekRevol Contact">Listen Now On Spotify</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default LatestEvents;